import $api from "@/frontend/shared/api/axios";

export type TNoteResponse = {
  content: string;
  section: string;
  createdAt: string;
  createdBy: {
    profileImageUrl: number;
    firstName: string;
    lastName: string;
  };
};

export async function getCompanyListNotes({ id }: { id: number }): Promise<TNoteResponse[]> {
  const response = await $api.get(`/companies/${id}/notes`);
  return response.data.data;
}
